import tw from 'twin.macro';

export const SectionContainer = tw.div`
py-24 sm:py-28
`;

export const GridContainer = tw.div`
grid grid-cols-1 md:grid-cols-2 gap-6 mx-auto max-w-7xl px-6 lg:px-8
`;

export const PropertyCard = tw.div`
 bg-white border rounded shadow max-w-xl flex-1 basis-1/3
`;

export const ImageCardContainer = tw.div`
relative
`;

export const PropertyImage = tw.img`
w-full object-cover max-h-[300px]
`;

export const Badge = tw.div`
absolute top-0 right-0 bg-black text-white px-2 py-1 font-bold
`;

export const CardContent = tw.div`
p-4 text-center
`;

export const TitleLink = tw.a`
no-underline text-black font-bold hover:underline
`;

export const Heading = tw.h3`
font-semibold
`;

export const Address = tw.p`
font-semibold
`;

export const Features = tw.p`
font-semibold
`;

export const FeatureSeparator = tw.span`
 mx-1
`;

export const Price = tw.p`
text-2xl font-semibold
`;